export default __webpack_public_path__ + "static/lessons-b2ad4254ac565ec8789d092b1c3a195a.mp4";